import React, { useEffect, useState } from 'react';
import './Brand.css';
import Header from "./common/Header";
import {Link, useParams, useSearchParams} from "react-router-dom"; // Import useSearchParams
import FeaturedSection from "./common/FeaturedSection";
import httpService from '../services/HttpService';
import {formattedPrice} from "../utils/priceFormatter"; // Import your HttpService

const Brand = () => {
    const { brandId } = useParams();
    const [brand, setBrand] = useState(null);

    useEffect(() => {
        // Fetch brand data from API using HttpService
        localStorage.removeItem('selectedFilters');
        localStorage.removeItem('selectedSorting');
        sessionStorage.clear();
        httpService.get(`/brands/${brandId}`)
            .then(response => response.json())
            .then(data => setBrand(data))
            .catch(error => console.error('Error fetching brand data:', error));
    }, [brandId]); // Re-run effect if brandId changes

    if (!brand) {
        // return <p>Loading...</p>;
        return <p></p>;
    }

    return (
        <>
            <Header />
            <div className="brand-container">
                {brand.sections.map((section, index) => {
                    if (section.type === 'collection' || section.type === 'category') {
                        return (
                            <FeaturedSection
                                key={section.id}
                                title={section.name}
                                buttonText={section.button}
                                imageUrl={section.image.link}
                                linkTo={`/product?${section.filter_key}=${section.filter_value}&brand_name=${brand.name}`}
                                reverse={section.reverse}
                                btnLink={`/product?${section.filter_key}=${section.filter_value}&brand_name=${brand.name}`}
                                modelId={section.image.model_id || null}
                            >
                                <p>{section.description}</p>
                            </FeaturedSection>
                        );
                    }
                    if (section.type === 'look') {
                        return (
                            <FeaturedSection
                                key={section.id}
                                title={section.name}
                                buttonText={section.button}
                                imageUrl={section.image.link}
                                linkTo={`/look/${section.filter_value}`}
                                reverse={section.reverse}
                                btnLink={`/look/${section.filter_value}`}
                                modelId={section.image.model_id || null}
                            >
                                <p>{section.description}</p>
                            </FeaturedSection>
                        );
                    }
                    // Handle other types here
                    else if (section.type === 'product_list') {
                        return (
                            <div key={index} className="bsp-products-section">
                                <div className="bsp-product-list-section-title">{section.name}</div>
                                <section className="bsp-featured-products">
                                    {section?.products?.map((product, index) => (
                                        <div className="product-card" key={index}>
                                            <Link className="link" to={`/product/${product.id}`}>
                                                <div className="product-card-image-container">
                                                    <img
                                                        src={product.main_image?.link || "https://via.placeholder.com/150"}
                                                        alt={product.name}
                                                    />
                                                </div>
                                                <p>{product.name}</p>
                                                <p>{formattedPrice(product.price, product.actual_price, product.sale)}</p>
                                            </Link>
                                        </div>
                                    ))}
                                </section>
                            </div>
                        );
                    }
                    // Handle other types here
                    else if (section.type === 'look_list') {
                        return (
                            <div key={index} className="bsp-products-section">
                                <div className="bsp-product-list-section-title">{section.name}</div>
                                <section className="bsp-featured-products">
                                    {section?.looks?.map((product, index) => (
                                        <div className="product-card" key={index}>
                                            <Link className="link" to={`/look/${product.id}`}>
                                                <div className="product-card-image-container">
                                                    <img
                                                        src={product.main_image?.link || "https://via.placeholder.com/150"}
                                                        alt={product.name}
                                                    />
                                                </div>
                                                <p>{product.name}</p>
                                            </Link>
                                        </div>
                                    ))}
                                </section>
                            </div>
                        );
                    }
                    // Default fallback if needed
                    return null;
                })}
            </div>
        </>
    );
};

export default Brand;